import { Carousel } from '@fancyapps/ui/dist/carousel/carousel.esm.js'
import { Autoplay } from '@fancyapps/ui/dist/carousel/carousel.autoplay.esm.js'
import { define } from 'wicked-elements'
import '@fancyapps/ui/dist/carousel/carousel.css'

define('[data-component~="slider"]', {
  init() {
    this.id = this.element.id
    this.options = {
      infinite: true,
      Dots: this.element.hasAttribute('data-dots'),
      Navigation: false,
      Autoplay: {
        autoStart: this.element.getAttribute('data-autoplay'),
        timeout: 1000 * this.element.getAttribute('data-autoplay') || 3000,
      },
    }

    this.$slider = this.element.querySelector('[data-slider]')
    this.$prev = this.element.querySelector('[data-previous]')
    this.$next = this.element.querySelector('[data-next]')

    this.slider = new Carousel(this.$slider, this.options, { Autoplay })
  },
  connected() {
    if (this.$prev) {
      this.$prev.addEventListener('click', () => this.slider.slidePrev())
    }
    if (this.$next) {
      this.$next.addEventListener('click', () => this.slider.slideNext())
    }
  },

  disconnected() {
    this.slider.destroy()
  },
  handleCaption() {},
})
